<template>
  <div class="page_title">
    <div class="align py-3 px-4">
      <h1 class="px-1">
        <i class="fa-regular fa-flag icon"></i>
       Notícias solicitadas
      </h1>
      <router-link v-if="authStore.user.profile_type == 'publisher'" :to="{ name: 'articleRequestCreate' }">
        <PrimaryButton class="px-5" icon="fa-solid fa-solid fa-plus">Nova solicitação</PrimaryButton>
      </router-link>
    </div>
  </div>

  <div class="align p-4 space_title">

    <div v-if="!loading || articlesRequests.data.length" class="card">
      <div class="p-4" id="table_filter">
        <InputText placeholder="Buscar" v-model="filter.search" />
      </div>
      <div class="table_container">
      <table>
        <thead>
          <tr>
            <th>ID</th>
            <th>Título</th>
            <th>Status</th>
            <th>Data</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(article, key) in articlesRequests.data" :key="key">
            <td>
              {{ article.id }}
            </td>
            <td>
              {{ article.title }}
            </td>
            <td>
              <span class="badge" :style="'background-color: ' + article.status_color">{{ article.status_name }}</span>
            </td>
            <td class="text-nowrap">
              {{ $dateFormat(article.updated_at) }}
            </td>
            <td class="actions">
                <router-link :to="{ name: 'articleRequestView', params: { id: article.id }}">
                  <button class="btn btn-secondary">
                    <i class="fa-regular fa-edit"></i>
                  </button>
                </router-link>
            </td>
          </tr>

          <tr class="no_result" v-if="!articlesRequests || (articlesRequests.data && !articlesRequests.data.length)">
            <td colspan="10">
              Nenhum resultado encontrado
            </td>
          </tr>
        </tbody>
      </table>
      </div>
    </div>

    <ListPagination class="mt-4" :links="articlesRequests.meta.links" />

  </div>
</template>
  
<script setup>
import PrimaryButton from '@/components/PrimaryButton.vue'
import InputText from '@/components/InputText.vue'
import { onBeforeMount, ref, watch } from 'vue';
import { useArticleStore } from '@/stores/ArticleStore'
import { storeToRefs } from 'pinia';
import { useRouter, useRoute } from 'vue-router';
import ListPagination from '@/components/ListPagination.vue'
import { inject } from 'vue';
import { useAuthStore } from '@/stores/AuthStore';

const loader = inject('$loader');
const loading = ref(false);

const articleStore = useArticleStore();
const { articlesRequests, filter } = storeToRefs(articleStore);

const authStore = useAuthStore();

const router = useRouter();
const route = useRoute();

onBeforeMount(() => {
  filter.value = {};

  if (route.query.search) {
    filter.value.search = route.query.search;
  }

  if (route.query.site) {
    filter.value.site = route.query.site;
  }
  loadArticlesRequests();
});

watch(() => route.query.page, () => {
  window.scrollTo(0, 0);
  loadArticlesRequests();
});

watch(() => filter.value.search, debounce(() => {
  const new_query = { ...route.query, page: 1, search: filter.value.search };
  router.push({ query: new_query }).then(() => {
    loadArticlesRequests();
  });
}, 500));

function debounce(func, wait) {
  let timeout;
  return function (...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}

async function loadArticlesRequests() {
  loader.show();
  loading.value = true;
  filter.value.page = parseInt(route.query.page);

  await articleStore.getArticlesRequests();

  loader.hide();
  loading.value = false;
}
</script>